import {Inject, ModelEvents} from "@denishussar/html5-game-engine";
import {Texture} from "pixi.js";
import {GameLogic} from "../../../Logic/GameLogic";
import {AlbumsLibrary} from "../../../Models/AlbumsLibrary";
import {IPictureData} from "../../../Services/CloudDB/Contract";
import {CatalogFolderController, ICatalogFolderControllerOptions, IPictureTexture} from "./CatalogFolderController";
import {GameModel} from "../../../Models/GameModel";

export class CatalogFolderWithoutGloryController extends CatalogFolderController {
    constructor(
        @Inject _options: ICatalogFolderControllerOptions,
        @Inject _gameLogic: GameLogic,
        @Inject modelEvents: ModelEvents,
        @Inject model: GameModel,
    ) {
        super(_options, _gameLogic, modelEvents, model);
    }

    public async selectAlbum(id: string, tab = CatalogFolderController.OPEN): Promise<void> {
        if (this.inSelecting) return;

        if (id !== AlbumsLibrary.MY_COLLECTION) {
            await super.selectAlbum(id, tab);
            return;
        }

        this.inSelecting = true;

        this.startTimer();
        this.currenAlbum = id;

        this.gotoAndStop('journals');

        this.createScrollPane();
        this.scrollPane.setSize(this.scrollPaneRectMax.width, this.scrollPaneRectMax.height);
        this.scrollPane.display.y = this.scrollPaneRectMax.y;

        const albums = this.$model.albumLibrary.getAllAlbums();
        let pictures: IPictureData[] = [];

        for (let i = 0; i < albums.length; i++) {
            const album = albums[i];

            if (album.id === AlbumsLibrary.MY_COLLECTION) {
                continue;
            }

            for (let j = 0; j < album.pictures.length; j++) {
                const picture = this.$model.albumLibrary.getPictureData(album.pictures[j]);
                const save = this._gameLogic.getSave(picture.id);

                if (album.id === AlbumsLibrary.GLORIA || (save && save.src)) {
                    // const percent = save ? this._gameLogic.getPercentageProgress(save) : 0;
                    pictures.push(picture);
                }
            }
        }
        pictures = [... new Set(pictures)];
        // return pictures;
        await this.prepareTextures(pictures)
            .then((pictures) => {
                return Promise.resolve(this.sortPictures(pictures));
            })
            .then((pictures) => {
                this.firstIconOnPage = pictures[0].picture.id;

                return this.createScrollPaneContent(pictures);
            })
            .then((content) => {
                this.scrollPane.content = content;
                this.scrollBar.resetSliderPosition();

                // HACK
                this.scrollBar.visible = this.scrollPane.content.height > 1024;

                return Promise.resolve();
            })

        this.inSelecting = false;
    }

    protected sortPictures(pictures: IPictureTexture[]): Promise<IPictureTexture[]> {
        const source = pictures.splice(0);
        const temp: IPictureTexture[] = [];

        // images with progress
        for (let i = 0; i < source.length; i++) {
            const data = source[i];
            const save = this._gameLogic.getSave(data.picture.id);
            const percent = save ? this._gameLogic.getPercentageProgress(save) : 0;
            if (save && percent > 0 && percent < 100) {
                temp.push(data);
            }
        }
        temp.sort((a1, a2) => {
            const save1 = this._gameLogic.getSave(a1.picture.id);
            const save2 = this._gameLogic.getSave(a2.picture.id);
            //return this._gameLogic.getPercentageProgress(save1) < this._gameLogic.getPercentageProgress(save2) ? 1 : -1;
            return save1.timestamp < save2.timestamp ? 1 : -1;
        });
        while (temp.length > 0) {
            pictures.push(temp.shift());
        }

        // images without progress
        for (let i = 0; i < source.length; i++) {
            const data = source[i];
            const save = this._gameLogic.getSave(data.picture.id);
            if (!save || this._gameLogic.getPercentageProgress(save) === 0) {
                temp.push(data);
            }
        }
        temp.sort((a1, a2) => {
            const texture1 = a1.texture as Texture;
            const texture2 = a2.texture as Texture;
            return texture1.width > texture2.width ? 1 : -1;
        });
        while (temp.length > 0) {
            pictures.push(temp.shift());
        }

        // images completed
        for (let i = 0; i < source.length; i++) {
            const data = source[i];
            const save = this._gameLogic.getSave(data.picture.id);
            if (save && this._gameLogic.getPercentageProgress(save) === 100) {
                temp.push(data);
            }
        }
        temp.sort((a1, a2) => {
            const texture1 = a1.texture as Texture;
            const texture2 = a2.texture as Texture;
            return texture1.width > texture2.width ? 1 : -1;
        });
        while (temp.length > 0) {
            pictures.push(temp.shift());
        }

        return Promise.resolve(pictures);
    }
}
